import { FormFields } from "../modal/FormFields";
import { FormActions } from "../modal/FormActions";

interface InterestFormProps {
  name: string;
  email: string;
  message: string;
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  onClose: () => void;
  isSubmitting: boolean;
  validateName: (name: string) => boolean;
  validateEmail: (email: string) => boolean;
  translations: any;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

export const InterestForm = ({
  name,
  email,
  message,
  onNameChange,
  onEmailChange,
  onMessageChange,
  onClose,
  isSubmitting,
  validateName,
  validateEmail,
  translations,
  onSubmit,
}: InterestFormProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4 mt-4">
      <FormFields
        name={name}
        email={email}
        message={message}
        onNameChange={onNameChange}
        onEmailChange={onEmailChange}
        onMessageChange={onMessageChange}
        validateName={validateName}
        validateEmail={validateEmail}
        translations={translations}
      />
      <FormActions
        onClose={onClose}
        isSubmitting={isSubmitting}
        translations={translations}
      />
    </form>
  );
};